import { useCallback, useEffect, useRef } from "react";
import { getLocalUser } from "../../../components/functions/utilities";
import { useAppDispatch, useAppSelector } from "../../../redux/reduxHooks";
import type { ConnectionSocketPayload } from "../api/connectionHub.types";
import { selectConnectionHubSession } from "../state/connectionHub.selectors";
import { applyConnectionSocketUpdate } from "../state/connectionHubSlice";

export const useConnectionSocket = () => {
  const dispatch = useAppDispatch();
  const session = useAppSelector(selectConnectionHubSession);
  const effectiveCompanyIdRef = useRef<number | null>(null);

  useEffect(() => {
    const localCompanyId = Number(getLocalUser()?.companyId);
    effectiveCompanyIdRef.current = session.agencyClientId ??
      (Number.isFinite(localCompanyId) ? localCompanyId : null);
  }, [session.agencyClientId]);

  return useCallback((payload: ConnectionSocketPayload): void => {
    if (!payload || payload.companyId !== effectiveCompanyIdRef.current) return;
    dispatch(applyConnectionSocketUpdate(payload));
  }, [dispatch]);
};
